<template>
	<div class>
		<drawer
			:title="addEditTitle"
			:dialogShow="addEditShow"
			@handleChange="back"
		>
			<div slot="body">
				<div class="pay-mains">
					<div class="member-msg">
						<div class="member-border">
              <el-avatar shape="circle" :src="headerImg"></el-avatar>
							<div class="rows no-member">
                
								<p class="member-box">门店顾客</p>
							</div>
						</div>
					</div>
					<p class="order-title-boxs mtb24">
						<span class="blueBlock"></span><i>消费清单</i>
					</p>
					<div class="totals-box plr16">
            <el-row class="order-details">
							<el-col :span="10" class="pl10">商品名称</el-col>
							<el-col :span="3" class="divCenter"
								>单价(元)</el-col
							>
							<el-col :span="3" class="divCenter">数量</el-col>
							<el-col :span="4" class="divCenter"
								>小计(元)</el-col
							>

							<el-col :span="4" class="tRight pr10"
								>实付(元)</el-col
							>
						</el-row>
						<div class="order-scoll">
							<!-- 准备做滑动 -->
							<el-row
								v-for="(item,
								index) in parentForm.orderItemList"
								:key="index"
								class="mt20 order-good-detail"
							>
								<el-col :span="10" class="pl10">{{
									item.itemName
								}}</el-col>
								<el-col :span="3" class="color999 divCenter">{{
									item.salePrice
								}}</el-col>
								<el-col :span="3" class="color999 divCenter">{{
									item.itemNum
								}}</el-col>
								<el-col :span="4" class="color999 divCenter">{{
									item.itemNum * item.salePrice
								}}</el-col>

								<el-col :span="4" class="tRight pr10">{{
									item.realPayAmount
								}}</el-col>
								<el-col :span="3" class="pl10 mt20 color999"
									>技师：</el-col
								>
								<el-col :span="21" class="mt20 pr10">
									<div class="jishi">
										{{ item.staffNames }}
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
					<el-row class="orderTotal borderT fontSize18">
						<el-col :span="12" class="flex-row pb24">
							<p class="label">消费数量：</p>
							<p class="num">{{ parentForm.itemNum }}</p>
						</el-col>
						<el-col :span="12" class="flex-row pb24">
							<p class="label">合计金额：</p>
							<p class="money num">
								￥{{ parentForm.orderAmount }}
							</p>
						</el-col>
						<el-col :span="12" class="flex-row pb24">
							<p class="label">折扣优惠：</p>
							<span class="num moneys"
								>￥{{ parentForm.discountAmount }}</span
							>
						</el-col>
						<el-col :span="12" class="flex-row">
							<p class="label">实收金额：</p>
							<p class="moneys num fontSize20">
								￥{{ (Number(parentForm.realPayAmount) - Number(parentForm.couponAmount || 0)).toFixed(2) }}
							</p>
						</el-col>
					</el-row>
				</div>
				<div class="drawer-footer">
					<div class="btns">
						<el-button class="right-btn" @click="confirmMoney"
							>确定核销</el-button
						>
					</div>
				</div>
			</div>
		</drawer>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
import { decrypt, encrypt } from '../../../assets/javascript/untils';
export default {
	mixins: [minxin],
	components: {
		drawer
	},
	data() {
		return {
			addEditShow: false,
			addEditTitle: '确定核销',
			form: {
				orderId: '',
				payWay: 'cash',
				verifyCode: '',
				payCheckType: '',
				couponSendRecordId: '',
			},
			headerImg: require('../../../assets/images/headerImg.png'),
			parentForm: {
				memberId: '',
				realPayAmount: 0,
				couponAmount: 0,
			}
		}
	},
	created() {
		this.init()
	},
	mounted() {},
	methods: {
		back() {
      this.addEditShow = false;
		},
		handleChangeDrawer() {
			this.addEditShow = false;
		},
		init() {
			this.$on('set', function(org) {
				this.addEditShow = true;
				this.form = org;
        this.getDiscountCalculate();
			})
		},
		getDiscountCalculate() {
			this.$api.post(this.$url.order.o2oDiscountCalculate, this.form).then((res) => {
        if (res) {
          this.parentForm = res;
        }
      })
		},
		// 核销
		confirmMoney() {
      console.log(this.form);
      this.$api.post(this.$url.order.useConfirm, encrypt(JSON.stringify(this.form))).then(ret => {
        if (ret) {
          this.addEditShow = false;
          this.$router.push({
            path: '/collectMoney/otherRegistration',
            query: {
              qrUrl: ret,
              qrcode: this.form.consumeCode,
              appName: this.$route.query.appName
            }
          })
        } else {
          this.$api.get(this.$url.order.getToken).then(res => {
            if (res) {
              this.form.repeatToken = res;
            }
          })
        }
      })
		}
	}
}
</script>
<style scoped lang="less">
@import '../../../assets/css/edit.less';
.pay-mains {
	.titles-head {
		border-top: 0;
	}
	.member-msg {
		padding: 16px 16px 0;
		.member-border {
			width: 100%;
			background-size: 100% 100%;
			color: white;
			display: flex;
			align-items: center;
			border-radius: 10px;
			padding: 12px 15px;
			background: #3388ff;
			box-sizing: border-box;
			.member-box {
				margin-left: 10px;
				.mobile {
					line-height: 1.6;
					margin-right: 46px;
				}
			}
		}
	}
}
.btns {
	width: 100%;
	display: flex;
	padding: 10px 24px 10px;
	border-top: 1px solid #eee;
	.left-btn {
		width: 176px;
		height: 56px;
		color: #fff;
		font-size: 20px;
		background: #535a6c;
		border-radius: 4px;
	}
	.right-btn {
		flex: 1;
		width: 100%;
		color: #fff;
		font-size: 20px;
		height: 56px;
		background: #ff5449;
		border-radius: 4px;
	}
}
.order-scoll {
	height: calc(100vh - 460px);
	overflow-y: auto;
	.order-good-detail {
		padding-bottom: 20px;
		border-bottom: 1px solid #ebedf0;
	}
}
.orderTotal {
	padding: 23px 25px 0;
}
</style>
